import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadDprValidationCsv = (formData, onUploadProgress) =>
  axios.post(
    `${BASE_URL}/provider-payment/dpr/validation-upload/file`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    }
  );

export const getDprValidationUploadHistory = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/history`, {
    params,
    headers: getAuthHeaders(),
  });

export const getDprValidationUploaders = () =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/uploaders`, {
    headers: getAuthHeaders(),
  });

export const getDprValidationProcessedTransactions = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/processed`, {
    params,
    headers: getAuthHeaders(),
  });

export const getDprValidationDashboardSummary = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/dashboard`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportDprValidationDashboardCsv = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/dashboard/csv`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

export const refreshDprValidationSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/provider-payment/dpr/validation-upload/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );

export const exportDprValidationProcessedCsv = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/processed/csv`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

export const getDprValidationProcessedAiSummary = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/processed/ai-summary`, {
    params,
    headers: getAuthHeaders(),
  });

export const getDprValidationProcessedAiSummaryHistory = (params) =>
  axios.get(`${BASE_URL}/provider-payment/dpr/validation-upload/processed/ai-summary-history`, {
    params,
    headers: getAuthHeaders(),
  });
